import { optionalText } from '../copy/text.js';
export function FreezeIcon({
  active,
  label,
  accessibleLabel = label,
  onClick,
}: {
  active: boolean;
  label: string | undefined;
  accessibleLabel?: string | undefined;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className="freeze-icon"
      title={optionalText(label)}
      aria-label={optionalText(accessibleLabel)}
      aria-pressed={active}
      onMouseDown={(event) => event.stopPropagation()}
      onPointerDown={(event) => event.stopPropagation()}
      onKeyDown={(event) => {
        if (event.key === ' ' || event.key === 'Enter') event.stopPropagation();
      }}
      onDoubleClick={(event) => event.stopPropagation()}
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 20 20"
        aria-hidden="true"
        fill={active ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7 2h6l-1 6 3 3v2H5v-2l3-3-1-6Z" />
        <path d="M10 13v5" />
      </svg>
    </button>
  );
}
